<template>
  <div
    v-if="fileReady"
    :style="`overflow: auto;height: calc(100vh - ${minusHeight}px)`"
    class="d-flex align-items-center"
  >
    <div class="row no-gutters justify-content-center">
      <div class="col-10 col-sm-3 d-flex flex-column"></div>
      <div class="col-10 col-sm-6 d-flex flex-column">
        <h3 class="mg-b-25">{{ file.title }}</h3>
        <div
          v-if="hasPermission(['learningstudent']) && !file.isPublic"
          class="alert alert-warning"
          role="alert"
        >
          Файлыг үзэх боломжгүй
        </div>
        <a
          v-if="file.isPublic"
          target="_blank"
          :href="file.link"
          class="btn btn-primary btn-block"
          >Татах</a
        >
      </div>
      <div class="col-10 col-sm-3 d-flex flex-column"></div>
    </div>
    <!-- <v-container fill-height fluid >
        <v-row align="center"
            justify="center">
            <v-col>
              <div class="title text-center mb-2">{{file.title}}</div>
              <v-btn block rounded  color="success" target="_blank" :href="file.link"><v-icon class="mr-1">mdi-download</v-icon>Татах</v-btn>
            </v-col>
        </v-row>
      </v-container> -->
  </div>
</template>
<script>
import { fileInheritedDetail } from "@/api/media";
import { hasOneOf } from "@/libs/tools";

export default {
  name: "detail",
  props: {
    propFileId: {
      type: Number,
      default: () => null
    },
    prms: {
      type: Object,
      default: () => {}
    },
    minusHeight: {
      type: Number,
      default: () => 115
    }
  },
  data() {
    return {
      fileReady: false,
      file: {},
      deletingFileId: 0
    };
  },

  mounted() {
    this.init();
  },
  methods: {
    hasPermission(perrArr) {
      return hasOneOf(perrArr, this.$store.state.user.access);
    },
    init() {
      let _id = this.propFileId;
      if (_id == undefined) {
        _id = this.$route.params.id;
      }

      fileInheritedDetail({ params: { id: _id }, store: this.$store }).then(
        res => {
          if (res != false) {
            this.file = res.data.file;
            this.fileReady = true;
          }
        }
      );
    }
  }
};
</script>
